export const setPhoneCode = (state, data) => {
    state.phoneCode = data
}
